var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CInfoPageTemplate,{attrs:{"content-label":'订阅须知',"content-text":_setup.content,"button-text":'立即订阅'},on:{"button-click":_setup.goSubscription}})
}
var staticRenderFns = []

export { render, staticRenderFns }